// extracted by mini-css-extract-plugin
export var modalFooter = "_pz-0";